import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { omit } from 'lodash';

import { showMessage } from '@lib/actions';
import axiosClient from '@lib/utils/axiosClient';

import { PatientForm } from '../types';

type Data = {
  name: string;
  email: string;
  docusignTemplateId: string;
  patientForm: string;
  patientFormTemplate: string;
};
type Response = PatientForm;

const mutationFn = async (data: Data) => {
  const { docusignTemplateId } = data;
  const response = await axiosClient.post(`/v2/patientForms/docusign/envelope/${docusignTemplateId}`, {
    ...omit(data, 'docusignTemplateId'),
  });
  return response.data as Response;
};

export default function usePatientFormDocusignEnvelope() {
  const dispatch = useDispatch();

  const mutation = useMutation(mutationFn, {
    // TODO: Make errors management generic to all `react-query` mutations
    onError: (error: Error) => {
      dispatch(showMessage(error.message, 'error'));
    },
  });

  return mutation;
}
